function TableLoad() {
  return <div id="loader"></div>;
}

export default TableLoad;
